export default [
  {
    path: '/refund',
    name: 'refund',
    component: () => import('@/view/refund/index.vue')
  },
  {
    path: '/refund/service',
    name: 'refundService',
    component: () => import('@/view/refund/service.vue')
  }
]